module.exports = __webpack_public_path__ + "img/controle-acces.b26b6d47.svg";